import { RosTemplate, RosTemplateControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useNewTemplateUpdate = () =>
  useMutationWithLoading(
    async (param: { rosTemplate: RosTemplate; xTENANTID?: string }) =>
      new RosTemplateControllerApi(getConfigObject()).updateRosTemplate(
        param?.rosTemplate,
        param?.xTENANTID
      )
  );
